<script>
import PromotedTip from '@/components/Companies/PromotedTip.vue'

export default {
  components: {
    PromotedTip
  },
  props: {
    companies: {
      type: Array,
      required: false
    },
    constants: {
      type: Object,
      required: true
    },
    searchMode: {
      type: Boolean,
      required: false,
      default: false
    },
    searchData: {
      type: Object,
      required: false
    },
    isLoading: {
      type: Boolean
    }
  },
  data() {
    return {
      NoResults: 'CompaniesLobby_Search_NoResults',
      TryAgain: 'CompaniesLobby_Search_TryAgain',
      LoadMoreId: 'CompaniesLobby_Search_LoadMore',
      IndustrySearchTitle: 'CompaniesLobby_Search_IndustryTitleFormat'
    }
  },
  methods: {
    isPaging() {
      return (
        Object.keys(this.searchData).length &&
        this.searchData.Keys.some(item => item.KeyValue.Key === this.LoadMoreId)
      )
    },
    isIndustriesSearch() {
      return (
        Object.keys(this.searchData).length &&
        this.searchData.Keys.some(
          item => item.KeyValue.Key === this.IndustrySearchTitle
        )
      )
    },
    hasCompanies() {
      return this.companies && this.companies.length > 0
    },
    loadMoreCompanies() {
      this.$emit(
        'loadMoreCompanies',
        this.getString(this.searchData, 'CompaniesLobby_Search_LoadMore').Link
      )
    }
  },
  computed: {
    getCompanies() {
      if (this.searchMode) {
        return this.companies
      } else if (this.$vuetify.breakpoint.xsOnly) {
        return this.companies.slice(0, 3)
      } else if (this.$vuetify.breakpoint.smOnly) {
        return this.companies.slice(0, 8)
      }
      return this.companies.slice(0, 9)
    }
  },
  mounted() {
    // if there's only one company => redirect to company's page
    if (this.companies.length == 1) {
      this.$router.push('/' + this.companies[0].ToUrl)
    }
  }
}
</script>

<style scoped>
.prev-paging {
  justify-content: flex-start;
}
.next-paging {
  align-items: center;
  justify-content: center;
  max-width: 150px;
}
</style>
